// src/components/CatalogStateBar.jsx
import React from 'react';
import { Menu } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { CATALOG_SORT_KEYS } from '../i18n/sortKeys';

const CatalogStateBar = ({
  currentSort = 'longAgo',
  onSortChange
}) => {
  const { t } = useTranslation();

  const handleSortChange = (sortOption) => {
    if (onSortChange) {
      onSortChange(sortOption);
    }
  };

  return (
    <div className="bg-white px-2 pt-3 pb-2 border-b border-gray-200">
      <div className="flex justify-start items-center">
        <Menu as="div" className="relative inline-block text-left text-sm">
          <Menu.Button className="pt-1 pb-1 inline-flex items-center text-gray-800 hover:text-gray-900 focus:outline-none">
            <span className="text-sm">{t('list.sortBy')}</span>
            <span className="ml-1 font-bold">{t(`sort.${currentSort}`)}</span>
            <i className="fas fa-caret-down ml-1 text-xs text-gray-500"></i>
          </Menu.Button>

          <Menu.Items className="absolute left-0 mt-1 w-48 origin-top-left bg-white rounded-md shadow-lg border border-gray-200 z-50">
            <div className="py-1">
              {CATALOG_SORT_KEYS.map((option) => (
                <Menu.Item key={option}>
                  {({ active }) => (
                    <button
                      onClick={() => handleSortChange(option)}
                      className={`w-full text-left px-3 py-2 text-sm ${
                        active ? 'bg-gray-50' : 'text-gray-700'
                      } ${currentSort === option ? 'text-purple-600 font-medium' : ''}`}
                    >
                      {t(`sort.${option}`)}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </div>
          </Menu.Items>
        </Menu>
      </div>
    </div>
  );
};

export default CatalogStateBar;
